<template>
  <div class="container pt-5 pb-5">
    <LoadingBox v-if="isLoading" />

    <PrimarySectionTitle class="text-center">
      <h2>Cadastrando senha</h2>
    </PrimarySectionTitle>

    <div class="row justify-content-center">
      <div class="col-lg-6 col-xl-5 col-md-7 text-left">
        <AlertBox type="danger" v-if="hasError">
          <strong>O token informado é inválido ou já foi utilizado</strong>
          <br>
          <span>Caso você já possua uma senha cadastrada em sua conta pode acessá-la normalmente.</span>
          <br><br>
          <span>Caso precise de ajuda, contate nossa <router-link :to="{ name: 'support' }">Equipe de Suporte</router-link></span>
        </AlertBox>

        <form @submit.prevent="submit" v-else>
          <AlertBox type="info" v-if="!isLoading">
            <b>{{ user.firstname}}, você está quase lá!</b> Falta só cadastrar a senha para acessar sua conta CyberClass, ok?
          </AlertBox>

          <PrimaryInput
            v-model="form.password"
            type="password"
            :validation="$v.form.password"
            placeholder="Senha"
            :required="true"
          />

          <PrimaryInput
            v-model="form.password_confirmation"
            type="password"
            :validation="$v.form.password_confirmation"
            placeholder="Confirme a senha"
            :required="true"
          />

          <PrimaryButton
            class="mt-3"
            type="submit"
            :full="true"
            :disabled="$v.form.$invalid"
          >Cadastrar senha</PrimaryButton>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import authApi from '@/api/auth'
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import PrimaryInput from '@/components/form/PrimaryInput'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import AlertBox from '@/components/layout/AlertBox'
  import authPasswordRegistrationRules from '@/validations/auth/authPasswordRegistrationRules'
  import LoadingBox from '@/components/layout/LoadingBox'

  export default {
    components: {
      PrimarySectionTitle,
      PrimaryInput,
      PrimaryButton,
      AlertBox,
      LoadingBox,
    },

    data: () => ({
      isLoading: false,
      hasError: false,
      user: {},
      form: {
        password: '',
        password_confirmation: ''
      }
    }),

    validations: {form: authPasswordRegistrationRules},

    async mounted () {
      this.isLoading = true

      try {
        this.user = await authApi.getUserByRegistrationPendingToken(this.token)
      } catch (err) {
        this.hasError = true
        this.isLoading = false
      }

      this.isLoading = false
    },

    computed: {
      ...mapGetters('user', ['isLogged']),

      token () {
        return this.$route.params.token
      }
    },

    methods: {
      ...mapActions('auth', ['login']),

      async submit () {
        this.isLoading = true

        await authApi.updateUserRegistrionPendingPassword(this.token, this.form)

        if (!this.isLogged) {
          await this.login({ email: this.user.email, password: this.form.password })
        }

        window.location.href = '/'
      }
    }
  }
</script>


